module.exports = __webpack_public_path__ + "img/jiexi.19acec97.png";